export const SHOW_RATINGS = false